import Vue from 'vue';
import VueRouter from 'vue-router';


//Import views
import Main from '@/views/Main';
import Login from '@/views/Login';
import Register from '@/views/Register';
import QuotationOverviewPrint from '@/views/templates/QuotationOverviewPrint';
import ShipmentTracking from '@/views/tracking/ShipmentTracking';
import XeroAuthCallback from '@/views/xeroauth/XeroAuthCallback';


//Import user components
import UserDashboard from '@/components/user/UserDashboard';
import Quotations from '@/components/user/Quotations';
import Bookings from '@/components/user/Bookings';


import QuotationOverview from '@/components/user/QuotationOverview';
import Shipments from '@/components/user/Shipments';
import PortShipmentTasks from '@/components/user/PortShipmentTasks';
import ShipmentsCalenderView from '@/components/user/ShipmentsCalenderView';
import Invoices from '@/components/user/Invoices';
import UserAccount from '@/components/user/UserAccount';

//Import admin components
import AdminDashboard from '@/components/admin/AdminDashboard';
import AdminCompany from '@/components/admin/AdminCompany';
import AdminAccount from '@/components/admin/AdminAccount';
import AdminCustomerRank from '@/components/admin/AdminCustomerRank';

// Import Admin Board components
import AdminBoard from '@/components/admin/AdminBoard';

// Import Geography components
import AdminGeography from '@/components/admin/AdminGeography';
import AdminCountry from '@/components/admin/geography/AdminCountry';
import AdminPort from '@/components/admin/geography/AdminPort';
import AdminCity from '@/components/admin/geography/AdminCity';

import NewInvoice from '@/components/admin/invoice_management/NewInvoice';

import AdminPricingTable from '@/components/admin/AdminPricingTable';
import AdminPricingTableForex from '@/components/admin/pricing_table/AdminPricingTableForex';

import AdminPricingLocalCharges from '@/components/admin/pricing_table/AdminPricingLocalCharges';
import AdminPricingDGClassesCharges from '@/components/admin/pricing_table/AdminPricingDGClassesCharges';
import AdminPricingCustomsCharges from '@/components/admin/pricing_table/AdminPricingCustomsCharges';
import AdminPricingFCL from '@/components/admin/pricing_table/AdminPricingFCL';
import AdminPricingLCL from '@/components/admin/pricing_table/AdminPricingLCL';
import AdminPricingAir from '@/components/admin/pricing_table/AdminPricingAir';
import AdminPricingHaulage from '@/components/admin/pricing_table/AdminPricingHaulage';
import AdminPricingTransport from '@/components/admin/pricing_table/AdminPricingTransport';



Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'home',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/print-quotation-overview',
      name: 'print-quotation-overview',
      component: QuotationOverviewPrint,
    },
    //Account management routes
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/tracking',
      name: 'tracking',
      component: ShipmentTracking
    },
    {
      path: '/xero_callback',
      name: 'xero_callback',
      component: XeroAuthCallback
    },
    {
      path: '/user',
      name: 'user',
      component: Main,
      children: [{
          path: 'dashboard',
          name: 'userdashboard',
          component: UserDashboard
        },
        {
          path: 'quotations',
          name: 'quotations',
          component: Quotations,
        },
        {
          path: 'bookings',
          name: 'bookings',
          component: Bookings,
        },
        {
          path: 'quotation-overview',
          name: 'quotationoverview',
          component: QuotationOverview,
        },

        {
          path: 'shipments',
          name: 'shipments',
          component: Shipments
        },
        {
          path: 'shipmentscalendarview',
          name: 'shipmentscalendarview',
          component: ShipmentsCalenderView
        },
        {
          path: 'portshipmenttasks',
          name: 'portshipmenttasks',
          component: PortShipmentTasks,
        },
        {
          path: 'invoices',
          name: 'invoices',
          component: Invoices
        },

        {
          path: 'account',
          name: 'useraccount',
          component: UserAccount
        },
        {
          path: 'admin',
          name: 'admindashboard',
          component: AdminDashboard,
          children: [{
              path: 'account',
              name: 'adminaccount',
              component: AdminAccount
            },
            {
              path: 'company',
              name: 'admincompany',
              component: AdminCompany
            },
            {
              path: 'customerrank',
              name: 'admincustomerrank',
              component: AdminCustomerRank
            }
          ]
        },
        {
          path: 'geography',
          name: 'admingeography',
          component: AdminGeography,
          children: [{
              path: 'country',
              name: 'admincountry',
              component: AdminCountry
            },
            {
              path: 'port',
              name: 'adminport',
              component: AdminPort
            },
            {
              path: 'city',
              name: 'admincity',
              component: AdminCity
            }
          ]
        },
        {
          path: 'pricingtable',
          name: 'adminpricingtable',
          component: AdminPricingTable,
          children: [{
              path: 'forex',
              name: 'adminpricingtableforex',
              component: AdminPricingTableForex
            },
            {
              path: 'customs',
              name: 'adminpricingcustoms',
              component: AdminPricingCustomsCharges
            }, {
              path: 'cargotype',
              name: 'adminpricingdgclasses',
              component: AdminPricingDGClassesCharges
            },
            {
              path: 'localcharges',
              name: 'adminpricinglocalcharges',
              component: AdminPricingLocalCharges
            },
            {
              path: 'fcl',
              name: 'adminpricingfcl',
              component: AdminPricingFCL
            },
            {
              path: 'lcl',
              name: 'adminpricinglcl',
              component: AdminPricingLCL
            },
            {
              path: 'air',
              name: 'adminpricingair',
              component: AdminPricingAir
            },
            {
              path: 'haulage',
              name: 'adminpricinghaulage',
              component: AdminPricingHaulage
            },
            {
              path: 'transport',
              name: 'adminpricingtransport',
              component: AdminPricingTransport
            },
          ]
        },
        {
          path: 'adminboard',
          name: 'adminboard',
          component: AdminBoard
        },

        // Admin invoice management pages
        {
          path: 'newinvoice',
          name: 'newinvoice',
          component: NewInvoice,
        }
      ]
    }
  ],

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
});